import React from "react";
import { Container, Row, Col } from "@ui/wrapper";
import Timeline from "@ui/timeline";
import { SectionWrap } from "./style";

import ImageOne from "@data/images/about-us/about-us-01.jpg";
import ImageTwo from "@data/images/about-us/about-us-02.jpg";
import ImageThree from "@data/images/about-us/about-us-03.jpg";
import ImageFour from "@data/images/about-us/about-us-04.jpg";

const content = [
    {
        id: 1,
        year: "2019",
        images: [{ src: ImageOne }],
        title: "2019年，宁波九荣智控有限公司成立",
        description:
            "2019年的10月，东海之滨的一座城市，桂花飘香，在一个平凡的日子，本着科技兴国，打造中国首家资产性管理工业平台的初心--成立了宁波九荣智控，注册资本2000万元。成立之初，获评2019年镇海区“雄镇英才”三类项目，并获得补助资金300万元。",
    },
    {
        id: 2,
        year: "2020",
        images: [{ src: ImageTwo }],
        title: "2020年，云平台1.0上线",
        description:
            "公司在带头人张黎博士的带领下，公司一步步壮大，有员工十余名。公司的云平台1.0 上线并且运用到奉化区、海曙区、镇海区九龙湖镇、江北的水泵的项目中。",
    },
    {
        id: 3,
        year: "2021",
        images: [{ src: ImageThree }],
        title: "2021年，搬进新的办公大楼",
        description: "2021年，搬进新的办公大楼公司进一步扩大，有了自己的办公室",
    },
    {
        id: 4,
        year: "2022",
        images: [{ src: ImageFour }],
        title: "2022年，公司的云平台2.0上线",
        description:
            "2022年，公司的云平台2.0上线，并接入上万台边缘设备，设计液位、流量、水质等各类排水监测。",
    },
];

const TimelineArea = () => {
    return (
        <SectionWrap>
            <Container>
                <Row>
                    <Col lg={12}>
                        <Timeline items={content} />
                    </Col>
                </Row>
            </Container>
        </SectionWrap>
    );
};

export default TimelineArea;
